declare global {
  interface Window {
    YT?: { Player: unknown; loaded?: number };
    onYouTubeIframeAPIReady?: () => void;
  }
}

const PROXY_IFRAME_API_URL = '/youtube_proxy/iframe_api';

let apiPromise: Promise<void> | null = null;

// Loads the IFrame API through our proxy so youtube-video-element finds
// window.YT already populated and never requests www.youtube.com directly.
export function loadYouTubeIframeApi(): Promise<void> {
  if (window.YT?.Player) return Promise.resolve();

  if (!apiPromise) {
    apiPromise = new Promise<void>((resolve) => {
      const previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        previous?.();
        resolve();
      };

      const script = document.createElement('script');
      script.src = PROXY_IFRAME_API_URL;
      script.async = true;
      document.head.appendChild(script);
    });
  }

  return apiPromise;
}

export function isYouTubeUrl(url: string): boolean {
  return /youtube(-nocookie)?\.com|youtu\.be/.test(url);
}
